<template>
  <div class="supplier-tenders">
    <v-data-table
      calculate-widths
      class="supplier-tender-table"
      disable-pagination
      :headers="headers"
      hide-default-footer
      item-key="index"
      :items="items"
      :no-data-text="$t('Tenders.NoData')">
      <template v-slot:item="{ item }">
        <tr>
          <td
            v-for="header in headers"
            :key="header.value"
            :data-qa="header.dataQa">
            <router-link
              v-if="header.value === 'number'"
              class="bold"
              :to="{name: 'tenderitem', params: { id: item.id, org: $route.params.org}}">
              {{ item.number }}
            </router-link>
            <template v-else-if="header.value === 'biddingPeriodEnd'">
              {{ item.biddingPeriodEnd | formatDate }}
            </template>
            <TooltipedText
              v-else-if="header.value === 'subject'"
              class="text-left"
              :line-count="2"
              :value="item.subject"/>
            <template v-else-if="header.value === 'budget'">
              {{ item.budget | formSum }}
              <template v-if="item.budget">
                {{ $t('Tenders.hrn') }}
              </template>
            </template>
            <template v-else-if="header.value === 'amountOfDeal'">
              {{ item.amountOfDeal | formSum }}
              <template v-if="item.amountOfDeal">
                {{ $t('Tenders.hrn') }}
              </template>
              <div>{{ item.vatInclude ? $t('Tenders.WithVAT') : $t('Tenders.WithoutVAT') }}</div>
            </template>
            <StatusChip
              v-else-if="header.value === 'tenderStatus'"
              key-name="id"
              :status="getStatus(item, statuses)"
              value-name="title"/>
            <template v-else-if="header.value === 'isWinner'">
              <sIcon
                v-if="item.isWinner"
                type="accept"/>
            </template>
            <TooltipedText
              v-else-if="header.value === 'comment'"
              class="text-left"
              :line-count="1"
              :value="item.comment"/>
            <template v-else-if="header.value === 'dateAdd'">
              <div
                v-if="item.dateAdd || item.dateModify"
                data-qa="dateEvent">
                {{ $d(new Date(item.dateModify ? item.dateModify : item.dateAdd)) }}
              </div>
              <sTooltip
                v-if="(item.dateModify || item.whoModify) && (item.dateAdd || item.whoAdd)"
                trigger="hover">
                <sChip
                  v-if="item.dateModify || item.whoModify"
                  background="var(--green_chosen_light)"
                  color="var(--black-color)"
                  data-qa="modifiedChip">
                  {{ $t('Common.Modified') }}
                </sChip>
                <div
                  slot="content"
                  style="max-width: 280px;">
                  <KeyValue
                    v-if="item.dateAdd"
                    caption="Дата коментаря"
                    data-qa="modifiedChip_date"
                    :value="$d(new Date(item.dateAdd))"/>
                  <KeyValue
                    v-if="item.whoAdd"
                    caption="Ким додано"
                    data-qa="modifiedChip_who"
                    :value="item.whoAdd"/>
                </div>
              </sTooltip>
            </template>
            <template v-else-if="header.value === 'whoAdd'">
              <div>{{ item.whoModify ? item.whoModify : item.whoAdd }} </div>
              <StatusChip
                v-if="item.decision"
                data-qa="decisionChip"
                :status="item.decision"/>
            </template>
            <template v-else-if="header.value === 'ipAddress'">
              {{ item.ipAddress }}
            </template>
            <template v-else>
              {{ item[header.value] }}
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>
    <InfinityUpdater
      :action="infinityLoad"
      :active="infinity_load"
      call-on-mount
      :loading="loading"
      selector="#components-layout-supplier-item #content-container"/>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import { modalMixin, tenderMixin} from 'mixins'

export default {
  name: 'supplierTenders',
  mixins: [modalMixin, tenderMixin],
  data() {
    return {
      items: [],
      infinity_load: true,
      statuses: [],
      loading: false
    }
  },
  created() {
    this.$store.dispatch('setTenderStatuses').then(res => this.statuses = res)
  },
  computed: {
    headers() {
      const headers = [
        {text: this.$t('Suppliers.TenderNumber'), value: 'number', width: '10%', dataQa: 'tenderNumber'},
        {text: this.$t('Tenders.EndDate'), value: 'biddingPeriodEnd', width: '135px', dataQa: 'biddingPeriodEnd'},
        {text: this.$t('Tenders.Nomination'), value: 'subject', width: '10%', dataQa: 'tender_name'},
        {text: this.$t('Tenders.Budget'), value: 'budget', width: '10%', dataQa: 'budget'},
        {text: this.$t('Tenders.TheAmountOfProposals'), value: 'amountOfDeal', width: '10%', dataQa: 'amountOfDeal'},
        {text: this.$t('Purchasing.Status'), value: 'tenderStatus', sortable: false, width: '10%', dataQa: 'tenderStatus'},
        {text: this.$t('Tenders.Winner'), value: 'isWinner', sortable: false, width: '10%', dataQa: 'isWinner'},


        {text: this.$t('Suppliers.Comment'), value: 'comment', sortable: false, width: '10%', dataQa: 'comment'},
        {text: this.$t('Дата коментаря'), value: 'dateAdd', sortable: false, width: '10%', dataQa: 'dateEvent'},
        {text: this.$t('Ким додано'), value: 'whoAdd', sortable: false, width: '10%', dataQa: 'whoAdd'},
      ]

      if (this.$can('is', 'showFieldIpInMySuppliers')) {
        headers.push({ text: 'IP', value: 'ipAddress', width: '130px'})
      }
      return headers
    },
    per_page() {
      return Math.round(document.documentElement.clientHeight / 50 )
    },
  },
  methods: {
    async infinityLoad() {
      this.loading = true
      let items = await this.$store.dispatch('getSupplierTenders', {supplierOrgId: +this.$route.params.id , take: this.per_page, skip: this.items.length}) || []
      if ( items?.length < this.per_page ) {
        this.infinity_load = false
      }
      if ( items?.length ) {
        this.items.push(...items)
      }
      this.loading = false
    }
  },
  components: {
    KeyValue,
    StatusChip,
    TooltipedText,
    InfinityUpdater
  }
}
</script>
